// ボタン中央寄せ用棚
import React from 'react';
import { Row, Col } from 'react-bootstrap';

const RowCenterButton: React.FC = ({ children }) => {
  return (
    <Row className="row-center-button">
      <Col className="text-center">{children}</Col>
    </Row>
  );
};

export default RowCenterButton;
